import type { ReviewRead, Visibility } from '../types'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

export interface OutcomeTexts {
  rejectedTitle: string
  rejectedHint: string
  /** `null` — вторая строка не нужна: тексты сбоя сами зовут отправить снова. */
  retryHint: string | null
}

const publishTexts = (): OutcomeTexts => {
  const m = messagesNow(messages)
  return {
    rejectedTitle: m.rejectedTitle,
    // Повтор идёт тем же селектом доступа, что стоит сразу под плашкой: `ReviewRead`
    // не несёт ЗАПРОШЕННУЮ видимость, и кнопка «Отправить снова» угадывала бы её.
    rejectedHint: m.resubmitHint,
    // У сорвавшейся проверки нарушений нет — исправлять нечего.
    retryHint: m.retryHint,
  }
}
const updateTexts = (): OutcomeTexts => {
  const m = messagesNow(messages)
  return {
    rejectedTitle: m.updateRejectedTitle,
    // Отказ «Обновить» живой сущности: повтор — отдельное действие отправки обновления.
    rejectedHint: m.updateResubmitHint,
    retryHint: null,
  }
}

/**
 * Какие тексты исхода показывать — или `null`, если исход устарел. У НЕопубликованной
 * сущности отказ и сбой всегда актуальны. У живой — только отказ «Обновить», и только пока
 * есть несданные правки: иначе заявка относится к прошлому, а видна прежняя версия.
 * Общее для курса (`ReviewStatusPanel`) и статьи (`ArticleReviewPanel`).
 */
export const outcomeTexts = (
  review: ReviewRead | null,
  visibility: Visibility,
  hasUnsubmittedChanges: boolean,
): OutcomeTexts | null => {
  if (visibility === 'unpublished') return publishTexts()
  return review?.kind === 'update' && hasUnsubmittedChanges ? updateTexts() : null
}
